<template>
  <div>
    <div style="margin-top: 20px">
      <div class="example-preview table-responsive">
        <!-- Bulk action buttons -->
        <div class="d-flex align-items-center mb-8" v-if="selectedRows.length > 0">
          <span class="mr-4">Đã chọn ({{ selectedRows.length }})</span>
          <button class="btn btn-sm btn-success mr-4" @click="openDialogManyConfirm">
            Xác nhận lỗi
          </button>
          <button class="btn btn-sm btn-secondary" @click="clearSelection">
            <i class="el-icon-close"></i>
            Hủy
          </button>
        </div>

        <el-table @selection-change="handleSelectionChange" ref="multipleTable" size="mini" :data="dataWarning" border
                  style="width: 100%" empty-text="Chưa có dữ liệu">
          <el-table-column :selectable="checkSelectable" type="selection" width="50"/>
          <el-table-column width="120" prop="processingProcedure" label="Quy trình"/>
          <el-table-column width="130" prop="failedTask" label="Tác vụ lỗi"/>
          <el-table-column width="500" prop="detailError" label="Chi tiết lỗi"/>
          <el-table-column width="140" label="Xác nhận lỗi">
            <template #default="{ row }">
              <span :class="row?.confirmStatusColor" style="padding: 4px 10px; border-radius: 4px; white-space: nowrap">
                {{ row?.confirmStatus }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="120" label="Trạng thái">
            <template #default="{ row }">
              <span :class="row?.statusColor" style="padding: 4px 10px; border-radius: 4px; white-space: nowrap">
                {{ row?.status }}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="personInCharge" label="Người phụ trách tác vụ"/>
          <el-table-column width="150" prop="createdAt" label="Thời gian tạo"/>

          <el-table-column width="120" label="Hành động" align="center">
            <template #default="{ row }">
              <div class="d-flex justify-content-center">
                <el-tooltip v-if="row?.confirmStatus === 'Chưa xác nhận'" class="item" effect="dark"
                            content="Xác nhận lỗi" placement="top">
                  <button type="button" class="btn btn-xs btn-icon btn-outline-success "
                          @click="openDialogConfirmError(row)"><i class="el-icon-check"></i></button>
                </el-tooltip>
                <el-tooltip v-else class="item" effect="dark" content="Khôi phục lỗi" placement="top">
                  <button type="button" class="btn btn-xs btn-icon btn-outline-warning " @click="openDialogErrorRecovery(row)"><i class="el-icon-refresh"></i>
                  </button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
        title="Xác nhận lỗi"
        :visible.sync="errorConfirmDialogVisible"
        width="30%"
        :lock-scroll="false"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
    >
      <p>Vui lòng chọn kết quả sau khi xác minh:</p>
      <el-select v-model="confirmValue" placeholder="Chọn kết quả" size="small" style="width: 100%">
        <el-option
            v-for="item in confirmList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <div class="d-flex justify-content-end mt-4">
        <button type="button" class="btn btn-secondary mr-4" @click="handleCloseDialogConfirmError" :disabled="loadingConfirmDialog">Đóng</button>
        <button type="button" class="btn btn-primary" @click="confirmError()" :disabled="loadingConfirmDialog"><i v-if="loadingConfirmDialog" class="el-icon-loading"></i>Xác nhận</button>
      </div>
    </el-dialog>
    <el-dialog
        title="Khôi phục kết quả"
        :visible.sync="errorRecoveryDialogVisible"
        width="30%"
        :lock-scroll="false"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
    >
      <p>Vui lòng chọn kết quả sau khi xác minh:</p>
      <p style="word-break: break-word">Lỗi <span style="color: #0d99ff">{{dataConfirmError?.detailError}}</span>  sẽ được đưa về trạng thái Chưa xác nhận lỗi.</p>
      <p>Bạn có chắc chắn muốn thực hiện hành động này không?</p>
      <div class="d-flex justify-content-end mt-4">
        <button type="button" class="btn btn-secondary mr-4" @click="errorRecoveryDialogVisible = false" :disabled="loadingConfirmDialog">Đóng</button>
        <button type="button" class="btn btn-primary" @click="confirmErrorRecovery()" :disabled="loadingConfirmDialog"><i v-if="loadingConfirmDialog" class="el-icon-loading"></i>Xác nhận</button>
      </div>
    </el-dialog>
    <el-dialog
        title="Xác nhận lỗi"
        :visible.sync="manyConfirmDialogVisible"
        width="30%"
        :lock-scroll="false"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
    >
      <p>Vui lòng chọn kết quả cho {{selectedRows.length}} bản ghi sau khi đã xác minh:</p>
      <el-select v-model="confirmValue" placeholder="Chọn kết quả" size="small" style="width: 100%">
        <el-option
            v-for="item in confirmList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <div class="d-flex justify-content-end mt-4">
        <button type="button" class="btn btn-secondary mr-4" @click="handleCloseDialogManyConfirm" :disabled="loadingConfirmDialog">Đóng</button>
        <button type="button" class="btn btn-primary" @click="confirmManyError()" :disabled="loadingConfirmDialog"><i v-if="loadingConfirmDialog" class="el-icon-loading"></i>Xác nhận</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  DELETE_ERROR,
  EDIT_ERROR,
  BULK_CANCEL_ERROR,
  RESTORE_ERROR, CONFIRM_ERROR, RECOVERY_ERROR, CONFIRM_MANY_ERROR
} from "../../../../core/services/store/report-error/reportError.module";
import {STATUS_ERROR_CSS} from "../../../../core/option/warningError";
import {confirmList, YET_CONFIRM} from "../../../../common/define";

export default {
  name: "Table",
  components: {},
  props: {
    dataWarning: {
      type: Array,
      default: []
    },
    dataDeFileError: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {

      is_cancel_multiple: false,
      is_undo_processing: false,
      statusDefineCss: STATUS_ERROR_CSS,
      selectedRows: [],
      YET_CONFIRM,
      errorConfirmDialogVisible: false,
      errorRecoveryDialogVisible: false,
      manyConfirmDialogVisible: false,
      dataConfirmError: null,
      confirmList,
      confirmValue: null,
      loadingConfirmDialog : false,

    }
  },
  methods: {
    checkSelectable(row, index) {
      return row?.confirmStatus === 'Chưa xác nhận'
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
      // console.log('Selected rows:', val);
    },
    openDialogManyConfirm() {
      this.manyConfirmDialogVisible = true;
    },
    clearSelection() {
      this.$refs.multipleTable.clearSelection();
      this.selectedRows = [];
    },
    openDialogConfirmError(row) {
      this.dataConfirmError = row;
      this.$nextTick(() => {
        this.errorConfirmDialogVisible = true;
      })
    },
    openDialogErrorRecovery(row){
      this.dataConfirmError = row;
      this.$nextTick(() => {
        this.errorRecoveryDialogVisible = true;
      })
    },
    async confirmError() {
      this.loadingConfirmDialog = true
      try {
        await this.$store.dispatch(CONFIRM_ERROR,{id:this.dataConfirmError.id,payload:{result:this.confirmValue}})
        this.$message({
          message: 'Xác nhận lỗi thành công',
          type: 'success'
        });
        this.errorConfirmDialogVisible = false
        this.confirmValue = null
        this.$emit('getListError')
      }catch (e) {
        this.$message.error('Đã có lỗi xẩy ra');
      }finally {
        this.loadingConfirmDialog = false
      }
    },
    handleCloseDialogConfirmError() {
      this.errorConfirmDialogVisible = false
      this.confirmValue = null
    },
    async confirmErrorRecovery(){
      this.loadingConfirmDialog = true
      try {
        await this.$store.dispatch(RECOVERY_ERROR,{id:this.dataConfirmError.id})
        this.$message({
          message: 'Khôi phục kết quả thành công',
          type: 'success'
        });
        this.errorRecoveryDialogVisible = false
        this.$emit('getListError')
      }catch (e) {
        this.$message.error('Đã có lỗi xẩy ra');
      }finally {
        this.loadingConfirmDialog = false
      }
    },
    handleCloseDialogManyConfirm(){
      this.manyConfirmDialogVisible = false
      this.confirmValue = null
    },
    async confirmManyError() {
      this.loadingConfirmDialog = true
      let payload = {
        ids : this.selectedRows.map((row)=>row?.id),
        result: this.confirmValue
      }
      try {
        await this.$store.dispatch(CONFIRM_MANY_ERROR,payload)
        this.$message({
          message: 'Xác nhận lỗi thành công',
          type: 'success'
        });
        this.manyConfirmDialogVisible = false
        this.confirmValue = null
        this.$emit('getListError')
      }catch (e) {
        this.$message.error('Đã có lỗi xẩy ra');
      }finally {
        this.loadingConfirmDialog = false
      }
    },
  }
}
</script>

<style scoped>
.bg-success {
  background: #1BC5BD !important;
  color: white !important;
}

.bg-warning {
  background: #FF9900 !important;
}

.bg-gray {
  background: #6A6A6A !important;
  color: white !important;
}

.b-pagination {
  margin: 0 !important;
}

</style>

<style>
.el-table__row {
  height: 30px !important;
}
</style>